import { AxiosRequestConfig } from 'axios';
import { emeraldRequest } from 'src/common/api/emerald-request';
import { EmeraldRequestParams } from 'src/common/interfaces/requests/EmeraldRequestParams';

export const authenticateTlog = async (
  operatorCreds?: AuthenticateCommandDto,
  token?: string,
): Promise<void> => {
  const axiosConfig: AxiosRequestConfig = {
    url: '/auth/command-approval-tlog',
    method: 'POST',
    data: operatorCreds,
  };

  const emeraldRequestParams: EmeraldRequestParams = {
    config: axiosConfig,
    addPOSMetaData: true,
    showLoadingComponent: true,
    showLoggingInfo: false,
    sessionId: token,
  };
  return emeraldRequest<void>(emeraldRequestParams);
};

export interface AuthenticateCommandDto {
  operatorId?: string;
  approverId?: string;
  approverRole?: string;
  actionLabel?: string;
}
